<template>
    <header class="checkout-header">
        <a class="checkout-header-logo" href="/">
            <svg class="checkout-header-logo__icon">
                <use v-if="currentLang === 'ru'" xlink:href="#svg_logo_eng"></use>
                <use v-else xlink:href="#svg_logo_ukr"></use>
            </svg>
        </a>

        <div class="checkout-header-aside">
            <span>
                <a
                    :href="storeData.mcTelephone"
                    class="checkout-header-phone"
                >
                    <b class="checkout-header-phone__number">{{ storeData.mcTelephone }}</b>
                    <span
                        v-if="screenWidth >= 768"
                        class="checkout-header-phone__text"
                    >
                        {{ storeData.messages.freeFromMobile }}
                    </span>
                </a>
            </span>

            <registration-control />
        </div>
    </header>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

import DefProgramMe from "../def/DefProgramMe/DefProgramMe";

const { state, getters } = useStore();
const currentLang = computed(() => getters['results/getCurrentLang']);
const storeData = computed(() => state.results.storeInformation);

// console.log(currentLang);
</script>

<script>
export default {
    name: 'CheckoutHeader',
}
</script>

<style lang="scss" scoped>
.checkout-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    @include point-md{
        height: 74px;
    }
    @include point-lg{
        height: 96px;
    }
}
.checkout-header-logo{
    display: inline-block;
    &__icon{
        display: inline-block;
        width: 103px;
        height: 28px;
        fill: #191918;
        @include point-md{
            width: 118px;
            height: 32px;
        }
        @include point-lg{
            width: 178px;
            height: 48px;
        }
    }
}
.checkout-header-aside{
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-column-gap: 24px;
    align-items: center;
    @include point-md{
        grid-column-gap: 48px;
    }
    :deep{
        .registration-control__text,
        .registration-control__log-out,
        .registration-control__profile{
            display: none;
            @include point-md{
                display: inline-block;
            }
        }
    }
}
.checkout-header-phone{
    display: flex;
    flex-direction: column;
    &__number{
        font-weight: 700;
        font-size: 14px;
        line-height: 110%;
        @include point-md{
            font-size: 18px;
            margin-bottom: 2px;
        }
    }
    &__text{
        font-size: 12px;
        color: #757575;
    }
}
</style>